export const REGULAR_SEASON_WEEKS = 18;
export const WEEK_WINDOW_SIZE = 6;

export function parseWeekNumber(weekKey: string): number {
  const m = /-W(\d+)$/.exec(weekKey);
  return m ? Number(m[1]) : 1;
}

export function parseWeekYear(weekKey: string): number {
  const m = /^(\d+)-W/.exec(weekKey);
  return m ? Number(m[1]) : 2026;
}

/** Completed past weeks from week 1 through the live week plus the next five, stopping at the last regular-season week. */
export function weekWindow(
  liveWeek: number,
  size = WEEK_WINDOW_SIZE,
  last = REGULAR_SEASON_WEEKS,
): number[] {
  const end = Math.min(last, Math.max(1, liveWeek) + size - 1);
  const weeks: number[] = [];
  for (let n = 1; n <= end; n++) weeks.push(n);
  return weeks;
}
